import {
    createStudent,
    deleteStudent,
    initAccountPassword,
    unlinkStudentAccount,
} from "../../../network/Endpoint";
import {useEffect, useState} from "react";
import SelectClassMenu from "./components/SelectClassMenu";
import ButtonImg from "../components/ButtonImg";
import AddStudentBtn from "../../../assets/images/classes/add_student_btn.svg";
import ModifyFinClassBtn from "../../../assets/images/classes/modify_fin_btn.svg";
import ModifyClassBtn from "../../../assets/images/classes/modify_btn.svg";
import Modal from "../../../components/Modal";
import Button from "../components/Button";
import StudentsTable from "./components/StudentsTable";
import {messageToast} from "../../../components/Toast";
import CheckBoxOn from "../../../assets/images/classes/check_box_on.png";
import CheckBoxOff from "../../../assets/images/classes/check_box_off.png";
import ConsentModalOpenBtn from "../../../assets/images/classes/consentModalOpenBtn.png";
import {cloneDeep} from "lodash";
import {useRecoilRefresher_UNSTABLE, useRecoilValue} from "recoil";
import {fetchClassesSelector} from "../../../recoil/classes/classesState";
import {authState} from "../../../recoil/auth/authState";

const  StudentManagementPage = ({ mainClass, setMainClass, classes, setClasses, students, setStudents, savedStudents, teacherName, schoolName, setModifyCheck, isEditable, setIsEditable, fetchUpdateStudents, updateStudentInfo, setUpdateStudentInfo, updatedStudents, setUpdatedStudents, isModStudentConsent, setIsModStudentConsent, fetchGetStudents}) => {

    const [newStudentName, setNewStudentName] = useState('');
    const [newStudentNumber, setNewStudentNumber] = useState('');
    const [newStudentPassword, setNewStudentPassword] = useState('0000');
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [initPasswordIndex, setInitPasswordIndex] = useState(null);
    const [unlinkAccountIndex, setUnlinkAccountIndex] = useState(null);
    const [isUnlinkingAccount, setIsUnlinkingAccount] = useState(false);

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isInitPasswordModalOpen, setIsInitPasswordModalOpen] = useState(false);
    const [isUnlinkAccountModalOpen, setIsUnlinkAccountModalOpen] = useState(false);
    const [isModConsentModalOpen, setIsModConsentModalOpen] = useState(false);
    const [isAddConsentModalOpen, setIsAddConsentModalOpen] = useState(false);

    const [isAddStudentConsent, setIsAddStudentConsent] = useState(false);


    const [tempNumber, setTempNumber] = useState(null);
    const [tempName, setTempName] = useState(null);
    const [tempPassword, setTempPassword] = useState(null);

    const auth = useRecoilValue(authState);
    const refreshClasses = useRecoilRefresher_UNSTABLE(fetchClassesSelector);

    const fetchMakeStudent = async () => {
        try {
            const body = {
                classId: mainClass.classId,
                name: newStudentName,
                number: newStudentNumber,
                password: newStudentPassword
            };
            const res = await createStudent(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const student = res.data.data.student;

                // 학생 리스트 새로 가져오기
                if (fetchGetStudents) {
                    fetchGetStudents(mainClass.classId);
                }

                // mainClass와 classes 업데이트
                setMainClass({
                    ...mainClass,
                    studentsCount: mainClass.studentsCount + 1
                });

                setClasses((prevClasses) =>
                    prevClasses.map((clazz) =>
                        clazz.classId === mainClass.classId
                            ? { ...clazz, studentsCount: clazz.studentsCount + 1 }
                            : clazz
                    )
                );

                messageToast({message:"학생이 추가되었습니다.",description:student.number+"번 / "+student.name});
                setModifyCheck(true);
            } else {
                alert(`ERROR: 학생 추가중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('학생 추가중 오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };


    const fetchDeleteStudents = async (student) => {
        try {
            const body = {
                classId: mainClass.classId,
                studentId: student.studentId
            };
            const res = await deleteStudent(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                // 학생 리스트 새로 가져오기
                if (fetchGetStudents) {
                    fetchGetStudents(mainClass.classId);
                }

                // mainClass와 classes 업데이트
                setMainClass({
                    ...mainClass,
                    studentsCount: mainClass.studentsCount - 1
                });

                setClasses((prevClasses) =>
                    prevClasses.map((clazz) =>
                        clazz.classId === mainClass.classId
                            ? { ...clazz, studentsCount: clazz.studentsCount - 1 }
                            : clazz
                    )
                );

                refreshClasses();
                messageToast({message:"학생이 삭제되었습니다.",description:student.number+"번 / "+student.name});
                setModifyCheck(true);
            } else {
                alert(`ERROR: 학생 삭제중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('학생 삭제중 오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };

    const fetchInitPassword = async () => {
        try {
            const body = {
                studentId: students[initPasswordIndex].studentId
            }

            const res = await initAccountPassword(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                messageToast({message:"비밀번호가 초기화 되었습니다.",description:students[initPasswordIndex].number+"번 / "+students[initPasswordIndex].name});
                setIsInitPasswordModalOpen(false);
            } else {
                alert(`ERROR: 비밀번호 초기화 중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('비밀번호 초기화 중 오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };

    const fetchUnlinkAccount = async () => {
        setIsUnlinkingAccount(true);
        try {
            const body = {
                studentId: students[unlinkAccountIndex].studentId
            }

            const res = await unlinkStudentAccount(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                // 학생 리스트 새로 가져오기
                if (fetchGetStudents) {
                    fetchGetStudents(mainClass.classId);
                }

                messageToast({message:"아이디 연동이 해제되었습니다.",description:students[unlinkAccountIndex].number+"번 / "+students[unlinkAccountIndex].name});
                setIsUnlinkAccountModalOpen(false);
            } else {
                alert(`ERROR: 아이디 연동 해제 중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('아이디 연동 해제 중 오류가 발생했어요. 아크수학으로 문의해 주세요.');
        } finally {
            setIsUnlinkingAccount(false);
        }
    };

    const ClickAddStudentBtn = () => {
        setStudents(cloneDeep(savedStudents));
        setUpdateStudentInfo([]);
        setNewStudentNumber(students && students.length > 0 ? students[students.length - 1].number + 1 : 1);
        setNewStudentName('');
        setNewStudentPassword('0000');
        setIsEditable(false);
        setIsModStudentConsent(false);
        setIsCreateModalOpen(true);
        setIsAddStudentConsent(false);
    }

    const ClickEditBtn = () => {
        if(students && students.length>0){
            if(isEditable && updateStudentInfo.length>0){
                if(isModStudentConsent){
                    fetchUpdateStudents(true);
                    setIsEditable(!isEditable);
                }else{
                    messageToast({message:"학생정보 저장에 동의해주세요!",description:"동의하지 않으면 저장할 수 없습니다."});
                }
            }else{
                setIsEditable(!isEditable);
            }
        }else{
            messageToast({message:"수정가능한 학생이 없습니다.",description:"학생을 먼저 추가해 주세요."});
        }
    }


    const handleCreateStudent = () => {

        if (!newStudentNumber || newStudentNumber === '') {
            messageToast({ message: "학생 번호를 입력해 주세요!", description: "학생 번호가 없으면 저장할 수 없습니다." });
            return;
        }

        // 중복 체크
        const isDuplicate = students.some(student => student.number === Number(newStudentNumber));
        if (isDuplicate) {
            messageToast({ message: "학생 번호 중복 에러!", description: "이미 존재하는 학생 번호입니다." });
            return;
        }

        if(!newStudentName || newStudentName===''){
            messageToast({message:"학생 이름을 입력해 주세요!",description:"이름이 없으면 저장할 수 없습니다."});
            return;
        }
        if(!newStudentPassword || newStudentPassword.length!==4){
            messageToast({message:"접속번호를 확인해 주세요!",description:"4자리 숫자로 입력해 주세요."});
            return;
        }



        if(isAddStudentConsent) {
            fetchMakeStudent();
            setNewStudentName('');
            setNewStudentPassword('0000');
            setIsCreateModalOpen(false);
            setIsAddStudentConsent(false);
        }
        else{
            messageToast({message:"학생정보 저장에 동의해주세요!",description:"동의하지 않으면 저장할 수 없습니다."});
        }

    };

    const handleDeleteStudent = () => {
        fetchDeleteStudents(students[deleteIndex]);
        setDeleteIndex(null);
        setIsDeleteModalOpen(false);
    };

    const handleEditChange = (index, value, type) => {
        let tempStudents = [...students];

        if (type === 'number') {
            if(!tempNumber){
                setTempNumber(tempStudents[index].number);
            }
            if(value){
                tempStudents[index].number = parseInt(value, 10);
            }else{
                tempStudents[index].number = value;
            }
        } else if (type === 'name') {
            if(!tempName){
                setTempName(tempStudents[index].name);
            }
            tempStudents[index].name = value;
        } else if (type === 'password') {
            if(!tempPassword){
                setTempPassword(tempStudents[index].password);
            }
            tempStudents[index].password = value;
        }

        const existingIndex = updateStudentInfo.findIndex(
            (item) => item.studentId === tempStudents[index].studentId
        );
        let newUpdateStudentInfo;

        if (existingIndex !== -1) {
            newUpdateStudentInfo = [...updateStudentInfo];
            newUpdateStudentInfo[existingIndex] = { ...tempStudents[index] };
        } else {
            newUpdateStudentInfo = [...updateStudentInfo, tempStudents[index]];
        }

        setUpdateStudentInfo(newUpdateStudentInfo);
        setUpdatedStudents(tempStudents);
    };

    const validateInput = (index, value, type) => {
        if(type==="name"){
            if(value===""){
                alert("이름을 입력해 주세요");
                updatedStudents[index].name = tempName; // 이전 값으로 복원
                setTempName(null);
                return;
            }
        }else if(type==="password"){
            if (!/^\d{4}$/.test(value)) {
                alert(`비밀번호는 4자리 숫자여야 합니다..`);
                updatedStudents[index].password = tempPassword; // 이전 값으로 복원
                setTempPassword(null)
                return; // 함수 종료
            }
        }else if(type==="number"){
            if(value===""){
                alert("번호는 필수 입력값 입니다.");
                updatedStudents[index].number = tempNumber; // 이전 값으로 복원

                setTempNumber(null);
                return;
            }
            const parsedNumber = parseInt(value, 10);
            const matchingCount = students.filter(
                (student) =>
                    student.studentId !== students[index].studentId &&
                    student.number === parsedNumber
            ).length;

            if (value==null || matchingCount > 0) {
                alert("중복된 번호가 있습니다.");

                // 원래 값으로 복원
                setUpdatedStudents((prevStudents) => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index].number = tempNumber; // 이전 값으로 복원

                    setTempNumber(null);
                    return updatedStudents;
                });
            } else {
                // 값이 유효하다면 업데이트
                setUpdatedStudents((prevStudents) => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index].number = parsedNumber;
                    setTempNumber(null);
                    return updatedStudents;
                });
            }
        }
    }

    const setModConsent = () => {
        setIsModStudentConsent(true);
        setIsModConsentModalOpen(false);
    }


    const setAddConsent = () => {
        setIsAddStudentConsent(true);
        setIsAddConsentModalOpen(false);
    }


    useEffect(() => {
        setStudents(students);
        setNewStudentNumber(students && students.length > 0 ? students[students.length - 1].number + 1 : 1);
    }, [students]);

    return (
        <>
            <div className="mt-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
                학생의 정보를 수정하거나 학생을 추가/삭제할 수 있습니다.
            </div>

            <div className="sticky top-0 z-10 bg-[#F8F8F8] w-full">
                <div className="flex flex-wrap justify-center items-center mt-[60px] min-h-[52px]">
                    <div className="relative w-[572px] h-[60px]">
                        <SelectClassMenu
                            classList={classes}
                            setClasses={setClasses}
                            mainClass={mainClass}
                            setMainClass={setMainClass}
                            setStudents={setStudents}
                            savedStudents={savedStudents}
                            isEditable={isEditable}
                            setIsEditable={setIsEditable}
                            updateStudentInfo={updateStudentInfo}
                            setUpdateStudentInfo={setUpdateStudentInfo}
                            fetchUpdateStudents={fetchUpdateStudents}
                            isModStudentConsent={isModStudentConsent}
                            setIsModStudentConsent={setIsModStudentConsent}
                        />
                    </div>
                </div>
                <div className="text-[#50555F] text-[20px] font-medium my-3">
                    {teacherName && teacherName}&nbsp;|&nbsp;{schoolName && schoolName}
                </div>

                <div className="w-full flex justify-center items-center my-8">
                    <div className="w-[1044px] flex justify-between items-center mt-6">
                        {/* 왼쪽: 학생 정보 저장 동의 (없어도 공간 유지) */}
                        <div className="flex items-center w-[324px]">
                            {isEditable ? (
                                <>
                                    <ButtonImg
                                        image={isModStudentConsent ? CheckBoxOn : CheckBoxOff}
                                        onClick={() => setIsModStudentConsent(!isModStudentConsent)}
                                    />
                                    <div className="pl-[9px] mr-[13px] py-2 cursor-pointer"
                                         onClick={() => setIsModStudentConsent(!isModStudentConsent)}
                                    >학생 정보 저장에 동의합니다.</div>
                                    <ButtonImg
                                        image={ConsentModalOpenBtn}
                                        onClick={() => setIsModConsentModalOpen(true)}
                                    />
                                </>
                            ) : (
                                <div className="w-[300px]"></div> // 동의 버튼이 없을 때도 공간 유지
                            )}
                        </div>

                        {/* 오른쪽: 학생 추가 및 수정 버튼 */}
                        <div className="flex justify-end gap-4 ">
                            {/*<div className="flex items-center text-[#E9483D] font-[700]">*/}
                            {/*    *학생 정보 이용 동의를 완료해주세요.*/}
                            {/*</div>*/}
                            <button
                                className="bg-[#BFBFBF] rounded-full text-[#FFF] text-[20px] font-[700] py-[8px] px-[16px] hover:opacity-50"
                                onClick={() => window.open(`${process.env.REACT_APP_RESEARCH_URL}?classInfo=${mainClass?.imClassId}_${auth?.teacher?.mid}`, 'researchWindow', 'width=1000,height=870')}
                            >
                                동의서 등록
                            </button>
                            <ButtonImg
                                image={AddStudentBtn}
                                label="학생 추가"
                                onClick={() => ClickAddStudentBtn()}
                            />
                            <ButtonImg
                                image={isEditable ? ModifyFinClassBtn : ModifyClassBtn}
                                label={isEditable ? "수정 완료" : "정보 수정"}
                                onClick={ClickEditBtn}
                            />
                        </div>
                    </div>
                </div>

            </div>
            <StudentsTable
                data={students}
                onDelete={(index) => {
                    setDeleteIndex(index);
                    setIsDeleteModalOpen(true);
                }}
                onInitPassword={(index) => {
                    setInitPasswordIndex(index);
                    setIsInitPasswordModalOpen(true);
                }}
                onUnlinkAccount={(index) => {
                    setUnlinkAccountIndex(index);
                    setIsUnlinkAccountModalOpen(true);
                }}
                isEditable={isEditable}
                onEditChange={handleEditChange}
                validateInput={validateInput}
            />

            {/* 학생 추가 모달 */}
            <Modal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">학생 추가</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="mb-5 mt-8">
                    <label className="inline-block w-[70px] text-lg font-bold text-gray-700 mb-2 mr-3 text-right">
                        번호
                    </label>
                    <input
                        type="text"
                        value={newStudentNumber}
                        onChange={(e) => setNewStudentNumber(e.target.value)}
                        placeholder="학생 번호 입력"
                        className="border-[#557CFC] border-2 rounded-xl py-2 px-3 w-[231px] text-base"
                    />
                </div>
                <div className="mb-5">
                    <label className="inline-block w-[70px] text-lg font-bold text-gray-700 mb-2 mr-3 text-right">
                        학생 이름
                    </label>
                    <input
                        type="text"
                        value={newStudentName}
                        onChange={(e) => setNewStudentName(e.target.value)}
                        placeholder="학생 이름 입력"
                        className="border-[#557CFC] border-2 rounded-xl py-2 px-3 w-[231px] text-base"
                    />
                </div>
                <div className="mb-5">
                    <label className="inline-block w-[70px] text-lg font-bold text-gray-700 mb-2 mr-3 text-right">
                        접속 번호
                    </label>
                    <input
                        type="text"
                        value={newStudentPassword}
                        onChange={(e) => setNewStudentPassword(e.target.value)}
                        placeholder=""
                        className="border-[#557CFC] border-2 rounded-xl py-2 px-3 w-[231px] text-base"
                    />
                </div>
                <div className="flex justify-center items-center mb-8">
                    <ButtonImg
                        image={isAddStudentConsent ? CheckBoxOn : CheckBoxOff}
                        onClick={() => setIsAddStudentConsent(!isAddStudentConsent)}
                    />
                    <div className="pl-[9px] mr-[13px] py-2 cursor-pointer"
                         onClick={() => setIsAddStudentConsent(!isAddStudentConsent)}
                    >학생 정보 저장에 동의합니다.</div>
                    <ButtonImg
                        image={ConsentModalOpenBtn}
                        onClick={() => setIsAddConsentModalOpen(true)}
                    />
                </div>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsCreateModalOpen(false)}
                    />
                    <Button label="추가하기" onClick={handleCreateStudent}/>
                </div>
            </Modal>

            {/* 삭제 확인 모달 */}
             <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">학생 삭제</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="my-8 text-2xl font-normal">
                    <span className="text-[#355bdf]">[{students && students[deleteIndex] && students[deleteIndex].number}번/{students && students[deleteIndex] && students[deleteIndex].name}] </span><br/>
                    <div className="text-base w-full leading-tight"> 학생의 모든 정보와 학습 기록이 삭제되며 복구할 수 없습니다.<br/> 삭제하시겠습니까? <br/><span className="text-sm">(삭제정보: 미니북, 아크수학, 툴킷, AI매일수학, AI평어, 띵커벨, 클래스 툴)</span></div>
                </div>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsDeleteModalOpen(false)}
                    />
                    <Button label="삭제하기" onClick={handleDeleteStudent}/>
                </div>
            </Modal>

            {/* 비밀번호 초기화 확인 모달 */}
            <Modal
                isOpen={isInitPasswordModalOpen}
                onClose={() => setIsInitPasswordModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">비밀번호 초기화</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <p className="mt-8 text-2xl font-normal"><span className="text-[#355bdf]">[{students && students[initPasswordIndex] && students[initPasswordIndex].number}번/{students && students[initPasswordIndex] && students[initPasswordIndex].name}] </span><br/>비밀번호를 초기화 하시겠습니까?</p>
                <p className="text-[16px] font-[500] text-[#FC5955] mb-8 mt-5 ">비밀번호는 [0000]로 초기화 됩니다.</p>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsInitPasswordModalOpen(false)}
                    />
                    <Button label="초기화" onClick={fetchInitPassword}/>
                </div>
            </Modal>

            {/* 아이디 연동 해제 확인 모달 */}
            <Modal
                isOpen={isUnlinkAccountModalOpen}
                onClose={() => setIsUnlinkAccountModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">아크수학 아이디 연동 해제</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <p className="mt-8 mb-8 text-2xl font-normal">
                    <span className="text-[#355bdf]">[{students && students[unlinkAccountIndex] && students[unlinkAccountIndex].id}]</span><br/>
                    아크수학 아이디 연동을 해제하시겠습니까?
                </p>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsUnlinkAccountModalOpen(false)}
                        disabled={isUnlinkingAccount}
                    />
                    <Button label="연동 해제" onClick={fetchUnlinkAccount} disabled={isUnlinkingAccount}/>
                </div>
            </Modal>

            {/*학생 정보 수정 동의 모달*/}
            <Modal
                isOpen={isModConsentModalOpen}
                onClose={() => setIsModConsentModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">임시 학생 계정 생성을 위한 동의 사항</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[632px] mx-[15px]"></div>
                <div className="flex justify-center flex-col w-full">
                    <div className="flex justify-center text-[18px] font-[500] leading-5 w-[678px] text-left pt-[35px] px-[60px]">
                        1. 선생님 회원이 직접 ‘만 14세 미만 학생'의 임시 계정을 생성할 때 해당 학생의 ‘법정 대리인(보호자)’의 동의가 필요합니다.
                    </div>

                    <a href="https://download.i-scream.co.kr/data/%EC%95%84%EC%9D%B4%EC%8A%A4%ED%81%AC%EB%A6%BC_%EB%A7%8C14%EC%84%B8%EB%AF%B8%EB%A7%8C%EC%95%84%EB%8F%99%EC%9D%98%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4%EC%88%98%EC%A7%91%EC%9D%B4%EC%9A%A9%EC%97%90%EA%B4%80%ED%95%9C%EB%B2%95%EC%A0%95%EB%8C%80%EB%A6%AC%EC%9D%B8%EB%8F%99%EC%9D%98%EC%84%9C.hwp" download=".hwp">
                        <div className="text-center text-[#355BDF] text-[18px] font-[700] leading-5 underline pointer w-[678px] pt-[24px] px-[60px]">
                            [만 14세 미만 아동의 개인정보 수집・이용에 관한 법정 대리인 동의서]
                        </div>
                    </a>

                    <div className="text-[18px] font-[500] leading-5 w-[678px] text-left pt-[24px] px-[60px]">
                        2. 따라서 학생 계정 생성 시 선생님 회원이 각 학생의 ‘법정 대리인(보호자)’으로부터  서비스 이용 동의를 받은 것으로 간주하며, 아이스크림에서는 학생 회원의  개인 정보 및 서비스 동의를 별도로 받지 않습니다. 해당 학생의 ‘법정 대리인(보호자)’의 동의를 꼭 받아주세요.
                    </div>
                </div>
                <div className="flex justify-center gap-4 mt-[32px]">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400 w-[120px]"
                        onClick={() => setIsModConsentModalOpen(false)}
                    />
                    <Button
                        label="네,동의합니다"
                        className="text-black w-[146px]"
                        onClick={ () => setModConsent() }/>
                </div>
            </Modal>


            {/*학생 추가 동의 모달*/}
            <Modal
                isOpen={isAddConsentModalOpen}
                onClose={() => setIsAddConsentModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">임시 학생 계정 생성을 위한 동의 사항</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[632px] mx-[15px]"></div>
                <div className="flex justify-center flex-col w-full">
                    <div className="flex justify-center text-[18px] font-[500] leading-5 w-[678px] text-left pt-[35px] px-[60px]">
                        1. 선생님 회원이 직접 ‘만 14세 미만 학생'의 임시 계정을 생성할 때 해당 학생의 ‘법정 대리인(보호자)’의 동의가 필요합니다.
                    </div>

                    <a href="https://sdd256627-sdd256627.ktcdn.co.kr/download/%EC%95%84%EC%9D%B4%EC%8A%A4%ED%81%AC%EB%A6%BC_%ED%81%B4%EB%9E%98%EC%8A%A4%20%EC%84%9C%EB%B9%84%EC%8A%A4%20%EC%9D%B4%EC%9A%A9%EC%9D%84%20%EC%9C%84%ED%95%9C%20%EB%B3%B4%ED%98%B8%EC%9E%90(%EB%B2%95%EC%A0%95%EB%8C%80%EB%A6%AC%EC%9D%B8)%20%EB%8F%99%EC%9D%98%EC%84%9C%20%EB%B0%8F%20%EC%9C%84%EC%9E%84%EC%9E%A5.hwp" download=".hwp">
                        <div className="text-center text-[#355BDF] text-[18px] font-[700] leading-5 underline pointer w-[678px] pt-[24px] px-[60px]">
                            [만 14세 미만 아동의 개인정보 수집・이용에 관한 법정 대리인 동의서]
                        </div>
                    </a>

                    <div className="text-[18px] font-[500] leading-5 w-[678px] text-left pt-[24px] px-[60px]">
                        2. 따라서 학생 계정 생성 시 선생님 회원이 각 학생의 ‘법정 대리인(보호자)’으로부터  서비스 이용 동의를 받은 것으로 간주하며, 아이스크림에서는 학생 회원의  개인 정보 및 서비스 동의를 별도로 받지 않습니다. 해당 학생의 ‘법정 대리인(보호자)’의 동의를 꼭 받아주세요.
                    </div>
                </div>
                <div className="flex justify-center gap-4 mt-[32px]">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400 w-[120px]"
                        onClick={() => setIsAddConsentModalOpen(false)}
                    />
                    <Button
                        label="네,동의합니다"
                        className="text-black w-[146px]"
                        onClick={ () => setAddConsent() }/>
                </div>
            </Modal>
        </>
    )
}

export default StudentManagementPage;